/** @file
 *   Contains the LegalCompliance component.
 */
import { Typography, useTheme } from '@mui/material';

import { styled } from '@mui/system';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)(({ theme }) => ({
    color: theme.palette.font.link,
    textDecoration: 'none',
    cursor: 'pointer',
    ':hover': {
        textDecoration: 'underline'
    }
}));

/** @component
 * Creates the LegalCompliance component for the landing page.
 *
 * This creates text with links to the terms and conditions. The text reads:
 *  "By creating an account, you agree to Essentia Analytics' Terms & Conditions and Privacy Policy.
 * @returns {JSX.Element}
 * @constructor
 */
export const LegalCompliance = () => {
    const theme = useTheme();

    return (
        <Typography
            data-testid='legalCompliance'
            variant='body2'
            color={theme.palette.font.white}
            align='center'
            paragraph
        >
            {"By creating an account, you agree to Essentia Analytics' "}
            <br />
            <StyledLink
                to='/terms-of-use'
                target='_blank'
                data-analyticsid='terms-conditions'
            >
                Terms & Conditions
            </StyledLink>
            {' and '}
            <StyledLink
                to='/privacy-policy'
                target='_blank'
                data-analyticsid='privacy-policy'
            >
                Privacy Policy
            </StyledLink>
        </Typography>
    );
};
